import React from 'react';
import { ArrowLeft, Shield, Cookie, Server, Mail, Users, Clock, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-32 pb-16 px-6">
      <div className="max-w-4xl mx-auto">
        {/* Back Link */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-cyan-600 hover:text-cyan-700 mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        {/* Main Content */}
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <div className="flex items-center gap-3 mb-8">
            <Shield className="w-10 h-10 text-cyan-600" />
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
              Datenschutzerklärung
            </h1>
          </div>

          {/* Introduction */}
          <section className="mb-10">
            <p className="text-gray-600 leading-relaxed">
              Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten 
              daher ausschliesslich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, Schweizer DSG). 
              In dieser Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der 
              Datenverarbeitung im Rahmen unserer Website.
            </p>
          </section>

          {/* Responsible Party */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <Users className="w-5 h-5 text-cyan-600" />
              Verantwortliche Stelle
            </h2>
            <div className="bg-gray-50 rounded-lg p-6">
              <p className="text-gray-700 font-medium">DYALENT Science&Technology GmbH</p>
              <p className="text-gray-600">Hagnaustrasse 25</p>
              <p className="text-gray-600">4132 Muttenz</p>
              <p className="text-gray-600">Schweiz</p>
            </div>
          </section>

          {/* Cookies */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <Cookie className="w-5 h-5 text-cyan-600" />
              Cookies
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Unsere Website verwendet sogenannte Cookies. Dabei handelt es sich um kleine Textdateien, 
              die mit Hilfe des Browsers auf Ihrem Endgerät abgelegt werden. Sie richten keinen Schaden an.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten. Einige Cookies bleiben 
              auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Sie ermöglichen es uns, Ihren Browser 
              beim nächsten Besuch wiederzuerkennen.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Wenn Sie dies nicht wünschen, können Sie Ihren Browser so einrichten, dass er Sie über das 
              Setzen von Cookies informiert und Sie dies nur im Einzelfall erlauben.
            </p>
          </section>

          {/* Analytics & Tracking */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <FileText className="w-5 h-5 text-cyan-600" />
              Web-Analyse und Tracking
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Unsere Website nutzt Funktionen von Web-Analyse-Diensten. Die dadurch erhobenen Daten werden 
              verwendet, um die Nutzung unserer Website zu analysieren und zu verbessern.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Die Verarbeitung erfolgt auf Grundlage unseres berechtigten Interesses an der statistischen 
              Analyse des Nutzerverhaltens zu Optimierungszwecken gemäss Art. 6 Abs. 1 lit. f DSGVO.
            </p>
          </section>

          {/* Hosting */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <Server className="w-5 h-5 text-cyan-600" />
              Hosting
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Unsere Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen 
              Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Der Einsatz des Hosters erfolgt im Interesse einer sicheren, schnellen und effizienten 
              Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter.
            </p>
          </section>

          {/* Contact Form */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <Mail className="w-5 h-5 text-cyan-600" />
              Kontaktformular
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem 
              Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung 
              der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern 
              Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung 
              vorvertraglicher Massnahmen erforderlich ist.
            </p>
          </section>

          {/* Data Retention */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <Clock className="w-5 h-5 text-cyan-600" />
              Speicherdauer und Löschfristen
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Die von uns erhobenen personenbezogenen Daten werden für die Dauer der Geschäftsbeziehung 
              gespeichert. Nach Beendigung der Geschäftsbeziehung oder nach Erfüllung des Zwecks werden 
              die Daten gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Anfragen über das Kontaktformular werden nach 2 Jahren gelöscht, sofern keine längere 
              Aufbewahrung aus rechtlichen Gründen erforderlich ist.
            </p>
          </section>

          {/* User Rights */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <Users className="w-5 h-5 text-cyan-600" />
              Ihre Rechte (Auskunft, Löschung, Sperrung)
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, 
              Datenübertragbarkeit und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung Ihrer Daten 
              gegen das Datenschutzrecht verstösst oder Ihre datenschutzrechtlichen Ansprüche sonst in 
              einer Weise verletzt worden sind, können Sie sich bei der Aufsichtsbehörde beschweren.
            </p>
            
            <div className="bg-cyan-50 rounded-lg p-6 mt-6">
              <h3 className="font-semibold text-gray-900 mb-3">Ihre Rechte im Überblick:</h3>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <span className="text-cyan-600 font-bold">•</span>
                  <span><strong>Auskunftsrecht:</strong> Sie können Auskunft über Ihre bei uns gespeicherten Daten verlangen.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-600 font-bold">•</span>
                  <span><strong>Recht auf Löschung:</strong> Sie können die Löschung Ihrer Daten verlangen.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-600 font-bold">•</span>
                  <span><strong>Recht auf Sperrung:</strong> Sie können die Einschränkung der Verarbeitung verlangen.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-600 font-bold">•</span>
                  <span><strong>Widerspruchsrecht:</strong> Sie können der Verarbeitung Ihrer Daten widersprechen.</span>
                </li>
              </ul>
            </div>
          </section>

          {/* Contact for Data Protection */}
          <section className="border-t border-gray-200 pt-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Kontakt für Datenschutzanfragen
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Für Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte wenden Sie sich bitte an:<br />
              <strong>DYALENT Science&Technology GmbH</strong><br />
              Hagnaustrasse 25<br />
              4132 Muttenz, Schweiz<br /><br />
              E-Mail: <a href="mailto:info@alpenpro.ch" className="text-cyan-600 hover:text-cyan-700">info@alpenpro.ch</a><br />
              Telefon: <a href="tel:+41762652627" className="text-cyan-600 hover:text-cyan-700">+41 76 265 26 27</a>
            </p>
          </section>

          {/* Last Updated */}
          <div className="mt-10 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-400">
              Stand: Februar 2025
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
